import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AnalyzerTableData} from '../../components/ingetion-analytics/index-management/create-custom-index/select-analyzers/select-analyzers-table/selectAnalyzerTableMock';

const analyzerSelectionTableData: AnalyzerTableData[] = [
  {id: '1', fieldName: 'Document Title', analyzerName: 'Consilo Standard Text'},
  {id: '2', fieldName: 'Author', analyzerName: 'Consilio Standard CJK'},
  {id: '3', fieldName: 'Created Date', analyzerName: 'Consilio Standard CJK'},
  {id: '4', fieldName: 'Department', analyzerName: 'Email/URL'},
  {id: '5', fieldName: 'Category', analyzerName: 'Path'},
  {id: '6', fieldName: 'File Type', analyzerName: 'Consilio Standard CJK'},
  {
    id: '7',
    fieldName: 'Last Modified Date',
    analyzerName: 'Consilo Standard Text',
  },
  {id: '8', fieldName: 'Modified By', analyzerName: 'Email/URL'},
  {
    id: '9',
    fieldName: 'Version Number',
    analyzerName: 'Consilio Standard CJK',
  },
  {id: '10', fieldName: 'Document ID', analyzerName: 'Consilio Standard Text'},
];

const initialState: AnalyzerTableData[] = analyzerSelectionTableData
  .slice()
  .sort((a, b) => a.fieldName.localeCompare(b.fieldName));

export const selectAnalyzerSlice = createSlice({
  name: 'analyzer',
  initialState,
  reducers: {
    updateAnalyzer: (
      state,
      action: PayloadAction<{rowId: string; analyzerName: string}>
    ) => {
      const {analyzerName, rowId} = action.payload;

      const row = state.find((r) => r.id === rowId);
      if (row) {
        row.analyzerName = analyzerName;
      }
    },
  },
});

export const {updateAnalyzer} = selectAnalyzerSlice.actions;
export default selectAnalyzerSlice.reducer;
